import { MDCSnackbar } from '@material/snackbar';
import { MDCDialog } from '@material/dialog';
import { MDCRipple } from '@material/ripple';
import { MDCTextField } from '@material/textfield';
import {MDCMenu, DefaultFocusState} from '@material/menu';

function mdcMenuInit(classMenuId, classMenuAncorId = "") {
  const menuAppButtons = document.querySelectorAll('.' + classMenuId);
  if (menuAppButtons) {
    menuAppButtons.forEach(mab => {
        let timeoutHover;
        const mabm = document.querySelector('#' + mab.dataset.sid);
        const menu = new MDCMenu(mabm);
        menu.setDefaultFocusState(DefaultFocusState.NONE);
        // menu.setAnchorElement(mab);
        mab.addEventListener('mouseover', function () {
          if (!menu.open) { menu.open = true; }
          clearTimeout(timeoutHover);
          if (classMenuAncorId !== "") {
            menu.setAnchorElement(document.querySelector('.' + classMenuAncorId))
          }
          menu.setFixedPosition(true);
        })
        mab.addEventListener('mouseout', function () {
          timeoutHover = setTimeout(function() {
            menu.open = false;
            menu.setFixedPosition(false);
          }, 200);
        })
        // mab.addEventListener('mouseleave', function () {
        //   menu.open = false
        //   timeoutHover = setTimeout(function() { menu.open = false; }, 100);
        //   console.log('leave mab')
        //   menu.setFixedPosition(false);
        // })
        mabm.addEventListener('mouseenter', function () {
          if (!menu.open) { menu.open = true; }
          clearTimeout(timeoutHover);
        })
        mabm.addEventListener('mouseleave', function () {
          timeoutHover = setTimeout(function() {
            menu.setFixedPosition(false);
            menu.open = false;
          }, 100);
        })
        mab.addEventListener('click', function () {
         if (!menu.open) { menu.open = true; }
         clearTimeout(timeoutHover);
        });
        window.addEventListener("scroll", function() {
          if (menu.open) {
            menu.open = false;
          }
        });
      });
  }
}

mdcMenuInit('navigation-menu-button', 'navigation__top')
mdcMenuInit('gcat_menu')
mdcMenuInit('gcat_menu_sale')
mdcMenuInit('topcat_menu')

const hamburger = document.querySelector('.header__top__icons__hamburger');
const topHeader = document.querySelector('.header__top');

if (hamburger) {
  hamburger.addEventListener('click', () => {
    topHeader.classList.toggle('header__top--active');
  });
}

if (document.querySelector('.mdc-fab')) {
  const fabRipple = new MDCRipple(document.querySelector('.mdc-fab'));
}

export const ScrollToTop = () => {
  var element;
  var visible = false;
  var hideAfterY = 250;

  function scrollHandler(){
      if (element && hideAfterY > scrollY && !visible){
          element.classList.remove('header-small')
          visible = true;
      }
      if(element && hideAfterY < scrollY && visible){
          element.classList.add('header-small')
          visible = false;
      }
  }

  function clickHandler(){
      scrollTo(0,0);
  }

  function loadHandler(){
      element = document.querySelector(".header");
      // element.addEventListener("click", clickHandler);
  }

  window.addEventListener("load", loadHandler);
  window.addEventListener("scroll", scrollHandler);
}
ScrollToTop();

export const getCookie = (cname) => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') { c = c.substring(1); }
        if (c.indexOf(name) == 0) { return c.substring(name.length, c.length); }
    }
    return "";
}

export const showCookies = () => {
  const snackbar = new MDCSnackbar(document.querySelector('#CookieSnackbar'));
  snackbar.timeoutMs = 10000;
  snackbar.open();
}

//const caCookie = getCookie("ca");
//if(caCookie !== "yes"){
//  setTimeout(() => {
//    showCookies();
//  }, 10000)
//}

window.acceptCookies = () => {
  var d = new Date();
  const exdays = 365;
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = "ca=yes;" + expires + ";path=/";
}

const dialog = new MDCDialog(document.querySelector('.mdc-dialog'));
const dialogContent = document.querySelector('#DialogContent');
window.newsletterInitConfirm = () => {
  const emailField = new MDCTextField(document.querySelector('.mdc-text-field'));
  if (emailField.value === "") { return; }

  fetch('/newsletter/init-confirm', {
    method: 'POST',
    credentials: 'include',
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ "email": emailField.value })
  })
  .then(result => {
    const p = Promise.resolve(result.json());
    p.then(v => {
      if (v.result) {
        dialogContent.innerHTML = v.html;
        // dialog.open();
        // closeNewsletter();
      }
    });
  })
  .catch(err => {console.log(err)
  });
}

window.loadNewsletterInitConfirm = () => {
  fetch('/newsletter/init', {
    method: 'GET',
    credentials: 'include',
  })
  .then(result => {
    const p = Promise.resolve(result.json());
    p.then(v => {
      if (v.result) {
        dialogContent.innerHTML = v.html;
        const text_fields = document.querySelectorAll('.mdc-text-field');
        if (text_fields) {
          text_fields.forEach(tf => {
            new MDCTextField(tf)
          })
        }
      }
    });
  })
  .catch(err => {console.log(err)
  });
}

const ukLang = document.querySelectorAll('.ukLang');
if (ukLang) {
  ukLang.forEach(b => {
    b.addEventListener('click', () => {
     dialogContent.innerHTML = '<a href="https://www.pah.org.pl/en/ukraine/"><img src="/images/uksupport.jpg"></a>'
     dialog.open()
    })
  })
}

window.loadDiscountInitEmailActivate = () => {
  fetch('/newsletter/discount-init', {
    method: 'GET',
    credentials: 'include',
  })
  .then(result => {
    const p = Promise.resolve(result.json());
    p.then(v => {
      if (v.result) {
        dialogContent.innerHTML = v.html;
        const text_fields = document.querySelectorAll('.mdc-text-field');
        if (text_fields) {
          text_fields.forEach(tf => {
            new MDCTextField(tf)
          })
        }
      }
    });
  })
  .catch(err => {console.log(err)
  });
}


window.discountInitEmailActivate = () => {
  const emailField = new MDCTextField(document.querySelector('.mdc-text-field'));
  if (emailField.value === "") { return; }

  fetch('/newsletter/discount-init-email-activate', {
    method: 'POST',
    credentials: 'include',
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ "email": emailField.value })
  })
  .then(result => {
    const p = Promise.resolve(result.json());
    p.then(v => {
      if (v.result) {
        dialogContent.innerHTML = v.html;
        // dialog.open();
        // closeNewsletter();
      }
    });
  })
  .catch(err => {console.log(err)
  });
}

window.newsletterEmailSave = (email) => {
  if (email === "") { return; }
  fetch('/newsletter/init-email-save', {
    method: 'POST',
    credentials: 'include',
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ "email": email })
  })
  .then(result => {
    const p = Promise.resolve(result.json());
    p.then(v => {
      if (v.result) {
        dialogContent.innerHTML = v.html;
        // dialog.open();
      }
    });
  })
  .catch(err => {console.log(err)
  });
}

const start_buttons = document.querySelectorAll('.act_button');
if (start_buttons) {
  start_buttons.forEach(b => {
    b.addEventListener('click', function() {
      const c = b.dataset.c
      const p = b.dataset.p
      fetch('/' + c + '/' + p, {
          method: 'GET',
          credentials: 'include'
        })
        .then(result => {
          const p = Promise.resolve(result.json());
          p.then(v => {
            dialogContent.innerHTML = v.html;
            const text_fields = document.querySelectorAll('.mdc-text-field');
            if (text_fields) {
              text_fields.forEach(tf => {
                new MDCTextField(tf)
              })
            }
            dialog.open();
          });
        })
        .catch(err => {
          console.log(err)
        });
    })
  })
}

window.helpFormSend = () => {
  const fields = document.querySelectorAll('.mdc-text-field');
  const params = {}
  fields.forEach(f => {
    const field = new MDCTextField(f);
    params[field.input_.name] = field.value
  })

  fetch('/start/help-form-confirm', {
    method: 'POST',
    credentials: 'include',
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(params)
  })
  .then(result => {
    const p = Promise.resolve(result.json());
    p.then(v => {
      if (v.result) {
        dialogContent.innerHTML = v.html;
      }
      const text_fields = document.querySelectorAll('.mdc-text-field');
      if (text_fields) {
        text_fields.forEach(tf => {
          const f = new MDCTextField(tf)
          if (!v.result && v.params_warn.includes(f.input_.name)) {
            tf.classList.add('mdc-text-field--filled')
          } else {
            tf.classList.remove('mdc-text-field--filled')
          }
        })
      }
    });
  })
  .catch(err => {console.log(err)
  });
}
